import { createSelector } from 'reselect';
import { ShelfComposition } from 'lib/modelBuilder/constants';
import { makeSelectShelvesSelectedLastHistory } from 'containers/Configurator/selectors/history';
import { makeSelectShelvesSelected } from 'containers/Configurator/selectors/selection';

export const makeSelectShelvesSelectedOption = () =>
  createSelector(makeSelectShelvesSelected(), (shelvesSelected):
    | ShelfComposition
    | undefined => {
    let compositionSelected = undefined;
    if (shelvesSelected) {
      for (const shelf of shelvesSelected) {
        if (shelf.composition === ShelfComposition.Open) {
          if (
            compositionSelected !== undefined &&
            compositionSelected !== ShelfComposition.Open
          ) {
            return undefined;
          } else compositionSelected = ShelfComposition.Open;
        } else if (shelf.composition === ShelfComposition.TwoDoors) {
          if (
            compositionSelected !== undefined &&
            compositionSelected !== ShelfComposition.TwoDoors
          ) {
            return undefined;
          } else compositionSelected = ShelfComposition.TwoDoors;
        } else if (shelf.composition === ShelfComposition.FourDoors) {
          if (
            compositionSelected !== undefined &&
            compositionSelected !== ShelfComposition.FourDoors
          ) {
            return undefined;
          } else compositionSelected = ShelfComposition.FourDoors;
        }
      }
    }
    return compositionSelected;
  });

export const makeSelectHistoryShelvesSelectedOption = () =>
  createSelector(makeSelectShelvesSelectedLastHistory(), (shelvesSelected):
    | ShelfComposition
    | undefined => {
    let compositionSelected = undefined;
    if (shelvesSelected) {
      for (const shelf of shelvesSelected) {
        if (shelf.composition === ShelfComposition.Open) {
          if (
            compositionSelected !== undefined &&
            compositionSelected !== ShelfComposition.Open
          ) {
            return undefined;
          } else compositionSelected = ShelfComposition.Open;
        } else if (shelf.composition === ShelfComposition.TwoDoors) {
          if (
            compositionSelected !== undefined &&
            compositionSelected !== ShelfComposition.TwoDoors
          ) {
            return undefined;
          } else compositionSelected = ShelfComposition.TwoDoors;
        } else if (shelf.composition === ShelfComposition.FourDoors) {
          if (
            compositionSelected !== undefined &&
            compositionSelected !== ShelfComposition.FourDoors
          ) {
            return undefined;
          } else compositionSelected = ShelfComposition.FourDoors;
        } else if (shelf.composition === ShelfComposition.Drawer) {
          if (
            compositionSelected !== undefined &&
            compositionSelected !== ShelfComposition.Drawer
          ) {
            return undefined;
          } else compositionSelected = ShelfComposition.Drawer;
        }
      }
    }
    return compositionSelected;
  });
